<div>
    <div class="mt-4">
        <h4>Password Generator</h4>
        <div class="float-right">
            <button class="btn btn-primary" @click.prevent="generatePassword">
                Generate Password
            </button>
        </div>
        <br>
        <br>
        <div>
            <div class="form-group">
                <label>Random Password</label>
                <input type="text" class="form-control" v-model="password" disabled/>
            </div>
        </div>
        <div class="form-group">
            <label>Password Length</label>
            <input type="number" class="form-control" v-model="passwordGenerator.length" @change="onPasswordLengthChange"/>
        </div>
        <div class="form-group">
            <div class="form-check">
                <input class="form-check-input" type="checkbox" id="lowercaseCharactersCheckbox" v-model="passwordGenerator.lowercaseCharacters"
                    @change="onLowercaseLettersForPasswordChange">
                <label class="form-check-label" for="lowercaseCharactersCheckbox">
                  Lowercase Characters (e.g. abcdef)
                </label>
              </div>
        </div>
        <div class="form-group">
            <div class="form-check">
                <input class="form-check-input" type="checkbox" id="uppercaseCharactersCheckbox" v-model="passwordGenerator.uppercaseCharacters"
                    @change="onUppercaseLettersForPasswordChange">
                <label class="form-check-label" for="uppercaseCharactersCheckbox">
                  Uppercase Characters (e.g. ABCDEF)
                </label>
              </div>
        </div>
        <div class="form-group">
            <div class="form-check">
                <input class="form-check-input" type="checkbox" id="numbersCharactersCheckbox" v-model="passwordGenerator.numbers"
                    @change="onNumbersForPasswordChange">
                <label class="form-check-label" for="numbersCharactersCheckbox">
                  Numbers (e.g. 123456)
                </label>
              </div>
        </div>
        <div class="form-group">
            <div class="form-check">
                <input class="form-check-input" type="checkbox" id="symbolsCharactersCheckbox" v-model="passwordGenerator.symbols"
                    @change="onSymbolsForPasswordChange">
                <label class="form-check-label" for="symbolsCharactersCheckbox">
                  Symbols (e.g. *@#+%)
                </label>
              </div>
        </div>
        <div class="form-group">
            <div class="form-check">
                <input class="form-check-input" type="checkbox" id="excludeSimilarCharactersCheckbox" v-model="passwordGenerator.excludeSimilarCharacters"
                    @change="onExcludeSimilarCharactersForPasswordChange">
                <label class="form-check-label" for="excludeSimilarCharactersCheckbox">
                  Exclude Similar Characters (e.g. o,0,i,l,1)
                </label>
              </div>
        </div>
        <div class="form-group">
            <div class="form-check">
                <input class="form-check-input" type="checkbox" id="excludeAmbiguousCharactersCheckbox" v-model="passwordGenerator.excludeAmbiguousCharacters"
                    @change="onExcludeAmbiguousCharactersForPasswordChange">
                <label class="form-check-label" for="excludeAmbiguousCharactersCheckbox">
                  Exclude Ambiguous Characters (e.g. ~,;:.{}&lt;&gt;[]()/\'`)
                </label>
              </div>
        </div>
    </div>
</div>
